/**
 * The name an appearance is shown with (I-2510) — in „Bearbeiten für", in the
 * captions of the settings list („Geerbt von „Atelier““) and in the look
 * designer: a built-in's catalog caption, else the stored name.
 */
import { getAppearanceScheme } from '@blpde/nx-tokens';
import type { AppearanceEntry } from '@/appearance/appearances';

type Translate = (key: string, named?: Record<string, unknown>) => string;

/** An appearance's name: a built-in's catalog caption, else the stored name (else its id). */
export function appearanceName(t: Translate, id: string, entries: readonly AppearanceEntry[]): string {
  const entry = entries.find((item) => item.id === id);
  if (!entry || entry.builtin) {
    const scheme = getAppearanceScheme(id);
    if (scheme) return t(scheme.labelKey);
  }
  return entry?.name ?? id;
}
